/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Vat'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('vat'); // main translation loaded for vat
		$translatePartialLoader.addPart('vattype'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/vat/vat-dialog.html';

		return {
			/* new state for entity vat */
			/* to access: ui-ref="vat.list.new" */
			/* url: hostname/vat/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'VatDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'VatFactory',
									'NewVatFactory',
									function(VatFactory, NewVatFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Vat
										// - resuming the creation of a new new Vat AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return VatFactory.get({ id: $stateParams.vatId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewVatFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for vat new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for vat edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('vat', {
		/* abstract state for entity vat */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/vat',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Vats',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('vat.list', {
		/* list state for entity vat */
		/* to access: ui-ref="vat.list" */
		/* url: hostname/vat/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/vat/vats.html',
				controller: 'VatController',
			},
		},
	});

	$stateProvider.state('vat.detail', {
		/* detail state for entity vat */
		/* to access: ui-sref="vat.detail" */
		/* url: hostname/vat/detail/:vatId */
		url: '/detail/:vatId',
		views: {
			'content@': {
				templateUrl: 'app/entities/vat/vat-detail.html',
				controller: 'VatDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'VatFactory',
				function($stateParams, VatFactory) {
					return VatFactory.get({ id: $stateParams.vatId });
				},
			],
		},
	});

	/* url: http://<hostname>/vat/list/new */
	$stateProvider.state('vat.list.new', getNewState());
	/* url: http://<hostname>/vat/list/:vatId/edit */
	$stateProvider.state('vat.list.edit', getEditState('/:vatId/edit'));
	/* url: http://<hostname>/vat/detail/:vatId/edit */
	$stateProvider.state('vat.detail.edit', getEditState('/edit'));

	$stateProvider.state('user-vat', {
		/* abstract state for DTO UserVatListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/vat',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Vat',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserVatListDto */
		/* to access: ui-ref="user-vat.list" */
		/* url: http://<hostname>/user/vat/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/vat/vat-list-user.html',
				controller: 'UserVatListDtoController',
			},
		},
	};

	$stateProvider.state('user-vat.list', dtoListState);
});
